/**
 * Inspired by https://github.com/compstak/marionette-tabs
 */
module.exports = {
  Behavior: require('./behavior'),
  Model: require('./model'),
  Collection: require('./collection')
// Item: require('./TabItem'),
// ItemView: require('./TabItemView'),
// Collection: require('./TabsCollection'),
// CollectionView: require('./TabCollectionView')
}



// WEBPACK FOOTER //
// ./js/behaviors/tabs/index.js